









import Vue from 'vue'

export default Vue.extend({
  props: {
    root: Object, // Root
    match: String // Regex from search
  },
  computed: {
    highlighted (): string {
      if (this.match) {
        let re = new RegExp(`(${this.match})`)
        return this.root.radicals.replace(re, '<span class="highlight">$1</span>')
      } else {
        return this.root.radicals
      }
    }
  }
})
